<h4>Herzlich Willkommen im Sanakey-Portal!</h4>
<p>
  Zur Teilnahme an Verträgen zur besonderen Versorgung bieten wir für Sie als
  Patient folgende Möglichkeiten:
</p>
<p class="text-center">
  - Teilnahme direkt online bestätigen,<br/>
  - Informationen zur Teilnahme, dem besonderen Versorgungsangebot und zu
  Therapieinhalten abrufen,<br/>
  - Teilnahmeerklärungen herunterladen<br/>
  - Teilnahme online widerrufen<br/>
</p>
<p>
  Der Zugang ist besonders geschützt. Ihre Arztpraxis stellt Ihnen einen entsprechenden QR-Code oder Weblink für die
  Einschreibung zur Verfügung.<br>
  Durch Scannen des QR-Codes bzw. Öffnen des Weblinks startet der Vorgang zur digitalen Teilnahme am
  Versorgungsvertrag.
  Anschließend erhalten Sie eine Bestätigung per E-Mail mit einem persönlichen Link zum nachträglichen Abruf der
  Vertragsinformationen und Teilnahmeerklärung.
</p>
<p>
  Sollten Sie Fragen zur Teilnahme an Verträgen zur besonderen Versorgung haben,
  melden Sie sich bei Ihrem behandelnden Arzt, Ihrer Krankenkasse oder schreiben
  Sie uns eine E-Mail an
  <a href="mailto:service@sanakey-portal.de">service&#64;sanakey-portal.de</a>.
</p>
